import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=26614824&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=26614824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26614824",
  null
  
)

export default component.exports